module.exports = __webpack_public_path__ + "img/skridsko_omberg1.862af83d.jpg";